import Toastify from 'toastify-js';

// criar toastyfy de success
export const toastifySuccess = (props: { message: string }) => {
  Toastify({
    text: `<div class="font-raleway text-small-medium border border-success-500 bg-success-100 dark:bg-success-600 flex max-w-80 w-80 min-h-12">
      <div class="bg-success-500 py-1 px-0.5"><i class="mdi mdi-information-outline s"></i></div>
      <div class="text-success-600 dark:text-white py-1 px-2">
        <span>${props.message}</span>
      </div>
    </div>`,
    duration: 3000,
    gravity: 'top', // `top` or `bottom`
    position: 'right', // `left`, `center` or `right`
    style: {
      background: "transparent",
      boxShadow: "none",
      padding: "0",
    },
    stopOnFocus: true,
    escapeMarkup: false, // Permite HTML no texto
  }).showToast();
};

// criar toastyfy de error
export const toastifyError = (props: { message: string }) => {
  Toastify({
    text: `<div class="font-raleway text-small-medium border border-danger-500 bg-danger-50 dark:bg-danger-900 flex max-w-80 w-80 min-h-12">
      <div class="bg-danger-500 py-1 px-0.5"><i class="mdi mdi-information-outline s"></i></div>
      <div class="text-danger-700 dark:text-white py-1 px-2">
        <span>${props.message}</span>
      </div>
    </div>`,
    duration: 3000,
    gravity: 'top', // `top` or `bottom`
    position: 'right', // `left`, `center` or `right`
    style: {
      background: "transparent",
      boxShadow: "none",
      padding: "0",
    },
    stopOnFocus: true,
    escapeMarkup: false, // Permite HTML no texto
  }).showToast();
};

// criar toastyfy de warning
export const toastifyWarning = (props: { message: string }) => {
  Toastify({
    text: `<div class="font-raleway text-small-medium border border-tertiary-500 bg-tertiary-50 dark:bg-tertiary-900 flex max-w-80 w-80 min-h-12">
      <div class="bg-tertiary-500 py-1 px-0.5"><i class="mdi mdi-information-outline s"></i></div>
      <div class="text-tertiary-800 dark:text-white py-1 px-2">
        <span>${props.message}</span>
      </div>
    </div>`,
    duration: 3000,
    gravity: 'top', // `top` or `bottom`
    position: 'right', // `left`, `center` or `right`
    style: {
      background: "transparent",
      boxShadow: "none",
      padding: "0",
    },
    stopOnFocus: true,
    escapeMarkup: false, // Permite HTML no texto
  }).showToast();
};

// criar toastyfy de info
export const toastifyInfo = (props: { message: string }) => {
  Toastify({
    text: `<div class="font-raleway text-small-medium border border-primary-500 bg-primary-50 dark:bg-primary-900 flex max-w-80 w-80 min-h-12">
      <div class="bg-primary-500 py-1 px-0.5"><i class="mdi mdi-information-outline s"></i></div>
      <div class="text-primary-800 dark:text-white py-1 px-2">
        <span>${props.message}</span>
      </div>
    </div>`,
    duration: 3000,
    gravity: 'top', // `top` or `bottom`
    position: 'right', // `left`, `center` or `right`
    style: {
      background: "transparent",
      boxShadow: "none",
      padding: "0",
    },
    stopOnFocus: true,
    escapeMarkup: false, // Permite HTML no texto
  }).showToast();
};